module.exports = __webpack_public_path__ + "img/reason_img3.4115fdee.png";